export const DR_CHART_LABEL = {
  all: 'key8',
  run: 'key9',
  predicted: 'key9A',
};
